import { fetchUserAnalyticsByState } from "./fetchUserAnalyticsByState";
import { useUserAnalyticsDateRangeQuery } from "./useUserAnalyticsDateRangeQuery";
import type {
  UserAnalyticsByStateQueryParams,
  UserAnalyticsByStateResult,
} from "./userAnalyticsByStateTypes";

export const USER_ANALYTICS_BY_STATE_QUERY_KEY =
  "USER_ANALYTICS_BY_STATE" as const;

/**
 * Loads the per-state acquisition aggregates for the geographic chart. The
 * query key incorporates the date range so the cache invalidates whenever the
 * user picks a new window. The metric dropdown is purely client-side — every
 * row already carries all 5 metric fields, so no refetch is needed when the
 * user switches metric. Mirrors the staleness / focus behaviour of the other
 * user-analytics hooks.
 */
export function useUserAnalyticsByState(
  params: UserAnalyticsByStateQueryParams,
) {
  return useUserAnalyticsDateRangeQuery<UserAnalyticsByStateResult>(
    USER_ANALYTICS_BY_STATE_QUERY_KEY,
    params,
    () => fetchUserAnalyticsByState(params),
  );
}
